import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mx-auto mt-10 w-[400px] max-w-full px-4 lg:w-full" }
const _hoisted_2 = { class: "ocm-headline2 mb-4 w-[200px]" }

import { store } from "@/state/store";
import BenefitItems, { BenefitItem } from "@/components/BenefitItems.vue";
import { $t } from "@/main";


export default /*#__PURE__*/_defineComponent({
  __name: 'BenefitsLandingPage',
  props: {
    items: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_unref($t)("benefits_headline")), 1),
    (_ctx.items.length)
      ? (_openBlock(), _createBlock(BenefitItems, {
          key: 0,
          items: _ctx.items,
          "is-landing-page": _unref(store).isLandingPage
        }, null, 8, ["items", "is-landing-page"]))
      : _createCommentVNode("", true)
  ]))
}
}

})